import { useMutation } from "@tanstack/react-query";
import { fetchSubstanceFileUrl } from "@/services/substance_api";
import type { InventoryFileSlot, SubstanceKind } from "@/utils/types/substance";

export function useSubstanceFileUrl() {
  return useMutation({
    mutationFn: (v: {
      kind: SubstanceKind;
      id: number;
      inventoryId: string;
      slot: InventoryFileSlot;
    }) => fetchSubstanceFileUrl(v.kind, v.id, v.inventoryId, v.slot),
  });
}
